module.exports = __webpack_public_path__ + "static/media/pbintWhiteText.ae811910.png";